define([
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/prefs",
], function(Action,ActionFactory,csiPrefs) {

	/**
	 * This module can be used to show standalone "Views" button similar to old custom view management,
	 * but is only intended for use when configuring property views without an instance
	 */
	
	return ActionFactory.declare("CustomViewManageButton", Action, {
		/**
		 * @override
		 * Allow if user has custom view access
		 */
		hasAccess: function(ctx) {
			return ctx && (ctx.view.prefSiteOnly ? csiPrefs.hasAdminAccess() : csiPrefs.hasEditAccess());
		}
	});
});